import React from "react"
import SailPointTechDemo from "@views/integrations/sailpoint-tech-demo"
import SEO from "@components/SEO"

const SailPointTechIntegration = () => (
  <div>
    <SEO
      title="EngineID - SailPoint Technical Integration Demo"
      keywords={[
        `engineid`,
        `sailpoint`,
        `governance`,
        `integration`,
        `provision to cloud`,
        `permission management`,
        `single sign on`,
        `identity management`,
        `access management`,
      ]}
    />
    <SailPointTechDemo />
  </div>
)

export default SailPointTechIntegration
